
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase } from 't4core';
import { LocationUserInfo } from 't4core';
import { EditLocationUserDialog } from '../../dialogs/EditLocationUser/EditLocationUser';
@Component({
    styleUrls: ['./LocationUsers.css'],
    selector: 't4-LocationUsers',
    templateUrl: './LocationUsers.html',
})
export class LocationUsersComponent extends PageBase implements OnInit {

    public users: LocationUserInfo[] = [];

    constructor(el: ElementRef) {
        super(el, "Settings");
    }

    async ngOnInit() {
        this.users = await this.Api.get<LocationUserInfo[]>("Location/GetLocationUsers", null);
    }


    public async add() {
        var ret = await this.Dialog.open(EditLocationUserDialog).afterClosed().toPromise();

        if (ret) {
            await this.Api.post("Location/CreateLocationUser", null, {
                firstname: ret.Firstname,
                lastname: ret.Lastname,
                phone: ret.Phone,
                email: ret.Email,
                pinCode: ret.PinCode
            });

            this.ngOnInit();
        }
    }

    public async edit(item: LocationUserInfo) {
        var ret = await this.Dialog.open(EditLocationUserDialog, {
            data: {
                user: item,
            }
        }).afterClosed().toPromise();

        if (ret) {
            await this.Api.post("Location/UpdateLocationUser", null, {
                userId: ret.Id,
                firstname: ret.Firstname,
                lastname: ret.Lastname,
                phone: ret.Phone,
                email: ret.Email,
                pinCode: ret.PinCode
            });

            this.ngOnInit();
        }
    }

    public async delete(item: LocationUserInfo) {
        if (!await this.UI.confirm("Turbo.Settings.LocationUsers.headConfirmDelete", "Confirm removal", "Turbo.Settings.LocationUsers.msgConfirmDelete", "Are you sure that you want to remove this person?")) return;
        await this.Api.post("Location/DeleteLocationUser", null, {
                userId: item.Id
            });

            this.ngOnInit();
    }
}
